import { Component, Input, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class UiMessageComponent implements OnInit {
  @Input() type: string;
  @Input() size: string;

  cardClass: string;

  constructor() {}

  ngOnInit() {
    this.cardClass = this.getClassType(this.type);
  }

  getClassType(type) {
    const classObj = {
      error: 'red',
      warning: 'yellow',
      success: 'green',
      message: 'blue',
    };

    return classObj[type];
  }
}
